import { Divider } from 'antd'
import FileTabLink from '../FileTabLink'

const Files = ({ files, hideDivider, increaseIndexBy, displayFilename }) => {
  return (
    <div className='min-w-[7.25rem]'>
      {files?.length > 0 ? (
        <div className='flex flex-col gap-8 items-center'>
          {files.map((file, i) => (
            <FileTabLink
              key={i + increaseIndexBy}
              filename={displayFilename ? file.filename : undefined}
              fileLink={`${process.env.NEXT_PUBLIC_IMG_PATH}${file.path}`}
              index={i}
            />
          ))}
        </div>
      ) : !hideDivider ? (
        <Divider className='border-[#DDD] my-0' />
      ) : null}
    </div>
  )
}

export default Files
